import React from 'react'
import { createUseStyles } from 'react-jss'
import logo from '../../images/logo.png'

const SmallLogo = props => {
  const classes = useStyles()
  return (
    <>
      <img
        className={classes.logo}
        src={logo}
      />
    </>
  )
}

const useStyles = createUseStyles({
  logo: {
    width: '4em',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
})

export default SmallLogo
